<template>
<div>
  <div style=" background-image: url('/img/backgrounds/spider_3.png')">
    <div class="page-header page-header-small " >
      <div class="content-center">
        <div class="row">
          <div class="col-md-6 ml-auto mr-auto text-center">
            <h1 class="title">Product updates</h1>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div style="margin-top: -200px">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-10">
          <card>
            <div class="card-body">
              <h3 class="card-title text-uppercase">April 2025</h3>

              <p class="mt-4" style="font-size: large">
                New feature: Ticket overview for company bookings <badge type="danger ml-3">bookings</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Easily view all tickets purchased under a company’s group booking. This new section provides a clear list of all attendees, making group management and check-in smoother than ever.
              </p>

              <p class="mt-4" style="font-size: large">
                Improvements to bookings and resource management <badge type="danger ml-3">bookings</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Set Maximum Participants per Pricing Category on event pricing: Limit the number of types of participants allowed in each pricing category, giving greater control over booking caps and availability.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Ability to set an event’s resource requirement to zero, allowing it to be excluded from resource management calculations. Perfect for events or games that don't require any resources, giving users even more control over bookings and operations.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Control the order in which images appear in game settings, giving more flexibility in how content is displayed.
              </p>


              <p class="mt-4" style="font-size: large">
                Upgrades to gift cards<badge type="primary ml-3">purchases</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Users can now apply promotions to specific gift cards only, allowing more control over discounts and special offers tied to individual gift card types.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Editing Gift Cards in bulk - Making changes to gift cards just got easier! Users can bulk-update and edit details across multiple gift cards in one go — perfect for quick updates and large-scale adjustments.
              </p>

              <p class="mt-4" style="font-size: large">
                Enhancements to promo codes <badge type="primary ml-3">purchases</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                More granular ways to apply promo codes - Users now have the ability to create promo codes that apply to specific items from their inventory, allowing more targeted discounts for selected products.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Ability to apply bulk actions to promo codes, making it easier to manage and update multiple codes at once.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Strengthened security measures around applying promo codes during the booking process to prevent misuse.
              </p>


              <p class="mt-4" style="font-size: large">
                Improvements to payment settings <badge type="primary ml-3">purchases</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Granular application of taxes and fees: Users have the ability to apply taxes and fees to individual games, inventory items, and gift card types, allowing more control over pricing and customization.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Improved reporting for inclusive tax type: Added clearer tax linkage and now accurately records the tax portion of transactions where prices include tax. Allows better transparency for users and simplifies accounting and reporting.
              </p>
            </div>
          </card>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-lg-10">
          <card>
            <div class="card-body">
              <h3 class="card-title text-uppercase">March 2025</h3>

              <p class="mt-4" style="font-size: large">
                Inventory management upgrades<badge type="primary ml-3">purchases</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Add-on purchases: Users can now create add-ons that can be selected during the booking process.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Flexible inventory limits: Set unlimited quantities for inventory items and add-ons, or set purchase limits if needed.
              </p>

              <p class="mt-4" style="font-size: large">
                Improvements to purchases<badge type="primary ml-3">purchases</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Ability to permanently delete deactivated gift cards from transaction records, allowing users to keep reporting clean and organized.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Mark gift card types as internal-only, so they’re hidden from customers, but still usable by users' staff.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                New fee setting allows users to choose whether fees apply after promotions and discounts.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Personalize the message guests see after making a booking, with details like their name, game, or date filled in automatically via dynamic variables.
              </p>

              <p class="mt-4" style="font-size: large">
                Dashboard improvements <badge type="info ml-3">dashboards</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Dashboard widgets now support accounting and custom date ranges, giving users more control over how data is displayed based on their reporting needs.
              </p>

              <p class="mt-4" style="font-size: large">
                Game management enhancements<badge type="success ml-3">game management</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Added a new optional timer in the Advanced Game Tracker, to aid Game Masters to track pace more easily during games.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Added a Custom Time Field to the Game Tracker, allowing users to set custom time for unique situations — and is also editable for past games.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Users have the ability to set internal nicknames for games, helping teams stay organized behind the scenes.
              </p>
            </div>
          </card>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-lg-10">
          <card>
            <div class="card-body">
              <h3 class="card-title text-uppercase">February 2025</h3>

              <p class="mt-4" style="font-size: large">
                New feature: Modular dashboards  <badge type="info ml-3">dashboards</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Personalize dashboards by adding, removing, and rearranging widgets.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Users can display the data that matters most to them — whether it’s booking stats, performance graphs, transaction data, or customer insights, users can transform widgets to suit their unique needs.
              </p>

              <p class="mt-4" style="font-size: large">
                Reporting upgrades<badge type="default ml-3">reports</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Tip tracking – Enhanced Purchase reports includes columns for Tips and Tip Assignees, giving users better visibility into gratuity distribution.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Improved filtering capabilities across various fields for easier reporting.
              </p>

              <p class="mt-4" style="font-size: large">
                Booking system enhancements <badge type="danger ml-3">bookings</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Customize text and background colors for booking slots on external calendars, creating the ability for personalized organization.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Adding activity logs when blocking slots: Users can track instances where slots are manually made unavailable, improving visibility on slot statuses.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Enhanced bulk booking activity logging, improving users’ ability to track mass changes to booking slots.
              </p>

              <p class="mt-4" style="font-size: large">
                Game management updates<badge type="success ml-3">game management</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                View Total Game Time on the Game History Table: Users can easily see the duration of a past booking at-a-glance.
              </p>
            </div>
          </card>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-lg-10">
          <card>
            <div class="card-body">
              <h3 class="card-title text-uppercase">January 2025</h3>

              <p class="mt-4" style="font-size: large">
                New feature: Product Roadmap  <badge type="default ml-3">roadmap</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Introducing the Product Roadmap, a powerful new tool that replaces the legacy Changelog. The roadmap provides users with real-time updates on everything happening within the platform, fostering better transparency and engagement.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Get a complete view of issues, bugs, enhancements, features, and initiatives. Allows users to stay informed about both community-submitted requests and our internally planned work.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Voting and follow system: users can cast votes to highlight tickets of interest, or follow tickets to receive notifications about progress and changes.
              </p>

              <p class="mt-4" style="font-size: large">
                Enhancements to the booking system <badge type="danger ml-3">bookings</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Expanded bulk actions to provide more flexibility when managing bookings.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Ability to apply custom pricing to multiple bookings in one go.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Easily attach notes to multiple bookings during bulk actions, helping users keep better records and communication.
              </p>

              <p class="mt-4" style="font-size: large">
                Improvements to the Square integration<badge type="primary ml-3">purchases</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Customizable Note field: Add notes to Square payments with support for dynamic variables, allowing users to give detailed context for each transaction.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Ability to create a customer in Square during payment events, streamlining customer tracking and management.
              </p>
            </div>


          </card>

        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-lg-10">
          <card>
            <div class="card-body">
              <h3 class="card-title text-uppercase">December 2024</h3>

              <p class="mt-4" style="font-size: large">
                New feature: Google Calendar integration  <badge type="info ml-3">integrations</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Easily import and sync your Google Calendar with our system, making it simpler to manage your schedule.
              </p>

              <p class="mt-4" style="font-size: large">
                Enhancements to gift cards <badge type="primary ml-3">purchases</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Gift card customization: users can adjust the text and appearance of gift cards.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Enhanced gift card controls: Ability to activate, deactivate, and edit fields on gift cards.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Option to waive fees on gift card purchases.
              </p>

              <p class="mt-4" style="font-size: large">
                Improvements to schedules and booking system <badge type="danger ml-3">bookings</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Apply bulk actions to bookings, restricted only to specific time ranges, allowing users more precise control.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Clear all resource assignments in bulk, freeing up your resources to adjust staff booking assignments.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Performance enhancements to schedule creation.
              </p>

              <p class="mt-4" style="font-size: large">
                Waiver system enhancement <badge type="info ml-3">waivers</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                New option to show or hide past booking slots on the waiver page, allowing more control over visibility.
              </p>
            </div>


          </card>

        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-lg-10">
          <card>
            <div class="card-body">
              <h3 class="card-title text-uppercase">November 2024</h3>

              <p class="mt-4" style="font-size: large">
                Expanded gift card functionality   <badge type="primary ml-3">purchases</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Ability to define gift card types with additional custom settings,
                including activation, expiration, and delivery dates.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Option to sell gift cards at a discount by setting purchase value and purchase price.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Ability to activate and deactivate individual gift card type on customer-facing site.
              </p>

              <p class="mt-4" style="font-size: large">
                Advanced resource management<badge type="success ml-3">employee management</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                An updated auto-blocking algorithm. Tracking added when a resource is assigned to and freed from events.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Configure staff requirements and blocking options on events.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Granular configurations on resources, including custom labeling and user assignment.
                Ability to set the number of events a single resource can support at a time.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Bookings can be assigned to resource slots manually or automatically.
              </p>

              <p class="mt-4" style="font-size: large">
                UI polish <badge type="warning ml-3">general</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Ability to reorder Checklists, as well as open checklists in multiple tabs.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Ability to duplicate Checklists and Games.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Payment request link now available for easy copying on the transaction details page.
              </p>
            </div>
          </card>

        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-lg-10">
          <card>
            <div class="card-body">
              <h3 class="card-title text-uppercase">October 2024</h3>

              <p class="mt-4" style="font-size: large">
                Enhancement to payments and transactions   <badge type="primary ml-3">purchases</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Ability to create transactions independently of bookings for greater flexibility.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Customize visibility of taxes and fees on product page.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                A dedicated promo codes management interface with additional features to seamlessly copy promo codes across business locations,
                view archived promo codes, and more.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Configure any number of custom payment methods for internal transactions.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                A new email template for gift card purchases.
              </p>

              <p class="mt-4" style="font-size: large">
                Improved user account management <badge type="success ml-3">account settings</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Track user last login times.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Associate an existing account with a different email address.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                New, more granular permissions.
              </p>

              <p class="mt-4" style="font-size: large">
                Booking system improvements <badge type="danger ml-3">bookings</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Support for multi-day slots.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Smart default pricing based on game settings.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Better scheduling tools, such as save and duplicate schedule settings.
              </p>
            </div>
          </card>

        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-lg-10">
          <card>
            <div class="card-body">
              <h3 class="card-title text-uppercase">September 2024</h3>

              <p class="mt-4" style="font-size: large">
                New feature: Inventory Management   <badge type="success ml-3">inventory management</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Introducing simple inventory management with ability to easily categorize and track inventory items.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Seamlessly apply inventory to existing or new transactions.
              </p>

              <p class="mt-4" style="font-size: large">
                Enhanced customer notifications <badge type="warning ml-3">email</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Send payment requests with custom deposit amounts and custom payment options.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Automatically trigger refund confirmation emails when a refund is issued.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Cart abandonment email to recover potential lost sales.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Additional customization options on gift card email templates.
              </p>


              <p class="mt-4" style="font-size: large">
                Improvements to reports and event logging <badge type="info ml-3">reports</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Detailed activity logs for each booking slot for deeper insights into your bookings.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Expanded reporting capabilities include a new Promo Codes report type to track promotion effectiveness.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Flexible date ranges across all reports, with the retained ability to easily download all time data.
              </p>

              <p class="mt-4" style="font-size: large">
                Improved photos overlays <badge type="success ml-3">photos</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Support for additional dynamic variables on photo overlays to create a unique customer experience.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Ability to layer and organize photo overlay layers.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Easy team name management for personalized photos
              </p>
            </div>
          </card>

        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-lg-10">
          <card>
            <div class="card-body">
              <h3 class="card-title text-uppercase">August 2024</h3>

              <p class="mt-4" style="font-size: large">
                Expanded payment and purchase options   <badge type="primary ml-3">purchases</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Cart Management: New cart abandonment section, listing abandoned and active carts, to help recover potential lost sales.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Currency Support: Added support for AUD and NZD currencies, catering to a wider international customer base.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Addition of preset gift card values and game-specific values on internal gift card purchases, offering more flexibility in gifting options.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Additional promo code field for internal gift card purchases, enabling targeted promotions.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Ability to add multiple gift cards to existing transactions, increasing purchase convenience.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Internal payment collection now records the company user who processed the payment, improving accountability.
              </p>



              <p class="mt-4" style="font-size: large">
                Enhanced customer experience <badge type="success ml-3">customers</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Multilingual Support: Customer-facing pages now available in French and Spanish, including Waivers, Bookings, Payments requests, Surveys, and Emails, enhancing accessibility for a broader audience.              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Improved Booking Interface: Option to show/hide company logo and pricing rate labels on the booking site.
              </p>



              <p class="mt-4" style="font-size: large">
                Advanced booking management controls  <badge type="danger ml-3">bookings</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Ability to add additional bookings to existing transactions, enhancing customer convenience and operational efficiency.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                New feature to assign company users to specific booking slots, improving staff management.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Bulk update options for booking slots, including minimum booking notice and maximum booking time adjustments.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Enhanced granularity in booking slot event logging for better tracking and analysis.
              </p>

              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Override price feature now modifies pricing category by type (flat or per person), offering more precise pricing control.
              </p>


              <p class="mt-4" style="font-size: large">
                Improved reporting and customer insights   <badge type="info ml-3">reports</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                New "Payments" report type for enhanced financial analysis.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Games tab on Customer Details page now includes columns for notes, completion time, and hints, providing deeper insights into customer experiences and preferences.
              </p>


            </div>
          </card>

        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-lg-10">
          <card>
            <div class="card-body">
              <h3 class="card-title text-uppercase">July 2024</h3>
              <p class="mt-4" style="font-size: large">
                Dynamic pricing <badge type="danger ml-3">bookings</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Introducing flexible, customizable pricing options for individual booking slots.
                Users now have the ability to configure pricing dynamically through the booking calendar interface or during event schedule creation.
                This enhancement enables sophisticated pricing strategies that can be adjusted based on factors such as demand fluctuations or staff availability.
              </p>


              <p class="mt-4" style="font-size: large">
                Enhanced gratuity features   <badge type="primary ml-3">purchases</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Integration of tipping functionality on the booking platform, offering both preset and custom gratuity options.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Flexible tip management on the transaction details page, allowing for addition or removal of gratuities, and assignment of tips to staff.
              </p>

              <p class="mt-4" style="font-size: large">
                Granular email event logging   <badge type="warning ml-3">email</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Implementation of a comprehensive email event log accessible via both the transaction details and customer profile pages.
                This feature enables efficient monitoring and management of all customer email interactions.
              </p>

              <p class="mt-4" style="font-size: large">
                Waiver system enhancements   <badge type="info ml-3">waivers</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Customizable compact view:
                Introduction of a configurable compact layout option for the waiver page, optimizing screen real estate and improving user experience.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Kiosk mode:
                Development of a dedicated kiosk mode for the waiver page, facilitating efficient on-site waiver completion and management.
              </p>

              <p class="mt-4" style="font-size: large">
                Customer engagement metrics enhancement   <badge type="success ml-3">customers</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Implementation of new data fields to capture and monitor critical customer interaction milestones.
                Initial engagement timestamp records the date and time of a customer's first interaction with the company.
                Most recent interaction timestamp tracks the date and time of the customer's latest engagement.
              </p>

            </div>
          </card>

        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-lg-10">
          <card>
            <div class="card-body">
              <h3 class="card-title text-uppercase">June 2024</h3>
              <p style="font-size: large">
                Account cost tracking and billing <badge type="success ml-3">account settings</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i> We added cost tracking across all account usage, broken down by feature.
                This allows us to charge our users only for what they actually use.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i> The billing page allowing users to save their billing information, view upcoming charges for the billing period, as well as
                invoices, and ability to update the subscription plan.
              </p>
              <p class="mt-4" style="font-size: large">
                Enhancements to booking site payment methods  <badge type="primary ml-3">purchases</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                We now support multiple gift card or card payments in a single booking transaction. Users can stack multiple gift card payments and cover the remainder with credit card.
                This feature helps minimize the need for customers to contact the company directly to apply their gift card balance.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                We added several customization to the booking site, including the ability to hide the promo code field and change the placeholder
                text for the field allowing users more control over their customer experience on the booking site.
              </p>
              <p class="mt-4" style="font-size: large">
                Improvements to the internal booking calendar <badge type="danger ml-3">bookings</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                We added small improvements to the booking calendar on the internal platform. On the list view, we added the increment/decrement date buttons to mirror the calendar view.
                We also update the pricing rate labels for flat pricing.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                We added persistent booking page settings, so that the setting/view mode chosen by the user would persist across sessions and devices.
              </p>
            </div>
          </card>

        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-10">
          <card>
            <div class="card-body">
              <h3 class="card-title text-uppercase">May 2024</h3>
              <p style="font-size: large">
                Photo overlays <badge type="success ml-3">photos</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                New feature: overlays on player photos. User now have the ability to create custom overlays with optional dynamic variable and assign them to photos.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Photos with overlays added will now show up on game history pages, customer details, player portal, and customer email attachments.
              </p>

              <p class="mt-4" style="font-size: large">
                Developer API  <badge type="info ml-3">api</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Customer can use the developer API to pull their transaction data across all groups under an account. API is authenticated via API token that can be retrieved and rotated under Company Settings page.
              </p>

              <p class="mt-4" style="font-size: large">
                Enhancements to payments  <badge type="primary ml-3">purchases</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                We added custom expiration setting for payment requests, enabling users to define the time after a payment request is sent after which the transaction and associated booking will be cancelled.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Ability to mark a card payment as refunded without processing the refund which is useful for when a refund has already been processed via payment gateway.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Ability to override price on gift cards (internal only).
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Users can now create and configure custom payment methods. The order and description for the methods are completely user defined. The methods will show up on the booking site.
              </p>

              <p class="mt-4" style="font-size: large">
                Role-based access control  <badge type="success ml-3">account settings</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                You can now define custom user roles and assign them to account users.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Default user roles (admin, manager, game master) remain unchanged and come as default for all new accounts.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Custom user roles also allow users to configure email notification settings, allowing users to opt out of receiving certain system emails.
              </p>

              <p class="mt-4" style="font-size: large">
                Activity log  <badge type="success ml-3">account settings</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                We added account activity log, showing all state-changing actions performed on an account.
              </p>

              <p class="mt-4" style="font-size: large">
                General platform improvements  <badge type="warning ml-3">general</badge>
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                We added persistent filters across the platform pages with lists, such as  waivers, transactions, and more. Filter will now remain in place even after user refreshes the page or moves away from the page.
              </p>
              <p>
                <i class="tim-icons el-icon-arrow-right text-primary" ></i>
                Performed major backend upgrades to database and email service.
              </p>
            </div>
          </card>

        </div>
      </div>

    </div>
  </div>
</div>
</template>

<script>
import Badge from '@/components/Badge';
export default {
  name: "NewsAndUpdates",
  components: {Badge}
}
</script>

<style scoped>

</style>
